<template>
        <div id='alterlevel'>
              <NavTop title='下阶信息列表'/>
              <van-search
               v-model="keywords"
               show-action
               placeholder="请输入下阶手机号码"
               @search="onSearch"
               >
               <template #action>
                  <div @click="onSearch">搜索</div>
               </template>
               </van-search>
              <div class="maincontent">
                  <div class="block" v-for="(item,index) in clientlist" :key="index">
                      <div class="row">
                          <div class="label">会员名</div>
                          <div class="content">{{item.username}}</div>
                      </div>
                      <div class="row">
                        <div class="label">联系电话</div>
                        <div class="content">{{item.mobile}}</div>
                     </div>
                     <div class="row nobottom">
                        <div class="label">会员级别</div>
                        <div class="content">{{item.levelname}}</div>
                     </div>
                  </div>
              </div>  
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { Dialog,Popup,Search,Picker   } from 'vant';

export default {
  name: 'alterlevel',
  data(){
      return{
         keywords:'',
         clientlist:[]
      }
  },  
  
  created(){
      this.getList()
  },
  methods:{
      getList(){
         let level=this.$route.params.level
         if(level!=undefined && level!=''){
             this.$post("/user/getLevelList",{level:level,keywords:this.keywords}).then((data)=>{
                 if(data.result.success){
                    this.clientlist=data.result.info.clientlist
                 }
             })
         }
      },
      onSearch(){
         if(this.keywords==''){
            this.$toast("搜索关键字不能为空")
            return false
         }
         this.getList()
      }
  },
  components:{
      NavTop,
      [Dialog.Component.name]: Dialog.Component,
      [Popup.name]:Popup,
      [Search.name]:Search,
      [Picker.name]:Picker
  }
}
</script>
<style scoped>
#alterlevel{background-color:#F6F6F6;min-height: 100vh;}
.maincontent{border-radius: 0.2rem;display: flex;flex-flow: column nowrap;margin: 0.3rem;}
.block{background-color: #fff;border-radius: 0.2rem;display: flex;flex-flow: column nowrap;margin-top:0.25rem;padding: 0.1rem 0;}
.row{display: flex;flex-flow:row nowrap;border-bottom: 1px solid #e7e7e7;align-items: center;padding: 0.25rem;}
.label{width:2rem;font-size:0.35rem;color:#333;text-align: center;}
.content{font-size:0.35rem;color:#333;flex:1;text-align: left;}
.btn{margin-left: auto;padding: 0.15rem;background-color: #ee0a24;color: #fff;border-radius: 0.15rem;width:1.5rem;text-align: center;}
.fixcon{margin-bottom: 0px!important;}
::v-deep .van-popup{overflow: hidden!important;}
.nobottom{border-bottom: none!important;}
</style>


